<template>
  <div v-if="generalInfo" class="my-tests profile-board profile-card mb-5">
    <div class="d-flex align-center flex-wrap mb-3" style="gap: 12px">
      <h3>Мои тесты</h3>
      <v-chip small label :color="statusColor(generalInfo.test_status_code)" text-color="white">
        {{ generalInfo.test_status_title }}
      </v-chip>
      <v-spacer />
      <v-btn v-if="canContinue" color="primary" outlined small :to="`/test/${generalInfo.token}`">
        Перейти к тестированию
      </v-btn>
    </div>

    <div v-if="!tests.length" class="caption grey--text">Вам пока не назначены тесты.</div>
    <div v-for="test in tests" :key="test.test_code" class="my-tests__item">
      <div class="my-tests__main">
        <div class="font-weight-600">{{ test.title }}</div>
        <div class="my-tests__meta">
          <span v-if="test.time && test.time !== '00:00:00'">
            <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>{{ test.time }}
          </span>
          <span v-if="completedAt(test)">
            <v-icon x-small class="mr-1">mdi-calendar-check</v-icon>{{ completedAt(test) }}
          </span>
          <span v-if="hasCorrect(test)">Верных ответов: {{ test.correct_answers_count }}</span>
        </div>
      </div>
      <div class="my-tests__progress">
        <div class="caption">{{ test.answers_count }} / {{ test.questions_count }}</div>
        <v-progress-linear :value="percent(test)" height="6" rounded :color="statusColor(test.status_code)" />
      </div>
      <v-chip small label outlined :color="statusColor(test.status_code)">{{ test.status }}</v-chip>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { TESTING_STATUSES } from '@/common/constants/testingStatuses';

const COLORS = {
  [TESTING_STATUSES.COMPLETED]: 'success',
  [TESTING_STATUSES.IN_PROGRESS]: 'warning',
  [TESTING_STATUSES.NOT_COMPLETED]: 'primary',
  [TESTING_STATUSES.NOT_SEND]: 'error',
  [TESTING_STATUSES.NOT_STARTED]: 'grey',
};

// Свои тесты кандидата из get-me (tests_results.general_info): статус, прогресс и даты.
// Не зависит от вкладок кабинета, поэтому показывается и тогда, когда у группы нет прав на «Статус тестирования».
export default {
  name: 'CandidateMyTests',
  computed: {
    ...mapGetters({ results: 'users/candidate/results' }),
    generalInfo() {
      return this.results && this.results.general_info ? this.results.general_info : null;
    },
    tests() {
      const list = this.generalInfo && Array.isArray(this.generalInfo.tests) ? this.generalInfo.tests : [];
      // Сначала те, что в работе, затем по дате завершения (новые выше)
      const rank = (t) => (t.status_code === TESTING_STATUSES.COMPLETED ? 1 : 0);
      return [...list].sort((a, b) => rank(a) - rank(b)
        || (Date.parse(b.completed_at) || 0) - (Date.parse(a.completed_at) || 0));
    },
    // Ссылка на прохождение нужна, пока есть что проходить
    canContinue() {
      const info = this.generalInfo;
      return !!info && !!info.token && info.test_status_code !== TESTING_STATUSES.COMPLETED;
    },
  },
  methods: {
    statusColor(code) {
      return COLORS[code] || 'grey';
    },
    percent(test) {
      return test.questions_count ? Math.round((test.answers_count / test.questions_count) * 100) : 0;
    },
    // Верные ответы показываем только у логических тестов, как в карточке для админа
    hasCorrect(test) {
      return /logic/i.test(test.test_code) && test.status_code === TESTING_STATUSES.COMPLETED;
    },
    completedAt(test) {
      return test.completed_at && moment(test.completed_at).isValid() ? moment(test.completed_at).format('DD.MM.YYYY') : '';
    },
  },
};
</script>

<style scoped lang="scss">
.my-tests {
  &__item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 12px;
    margin-bottom: 8px;
    border: 1px solid #ececec;
    border-radius: 8px;
    background: #fff;
  }

  &__main {
    flex: 1 1 40%;
    min-width: 0;
  }

  &__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 2px;
    color: #888;
    font-size: 13px;
  }

  &__progress {
    flex: 0 0 160px;
  }
}

@media (max-width: 600px) {
  .my-tests__item {
    flex-wrap: wrap;
  }
}
</style>
